import { CircularProgress, List, ListItem, Divider } from "@mui/material";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import SelectField from "../../../Components/SelectField";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    minWidth: '520px',
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, fontFamily: "Quicksand" }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export const CreateDepartmentDialog = ({
  DepthandleClose,
  Deptopen,
  DepartmentUnit,
  setDepartment,
  AllEmployee,
  createDepartment,
  isLoading,
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={DepthandleClose}
      aria-labelledby="customized-dialog-title"
      open={Deptopen}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={DepthandleClose}
      >
        <div className="foundation_header">Create Department</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Form_Box">
          <div className="Box">
            <label>name</label>
            <input
              name="name"
              value={DepartmentUnit.name}
              onChange={(e) =>
                setDepartment({ ...DepartmentUnit, name: e.target.value })
              }
            />
          </div>

          <div className="Box">
            <label>Head of Department</label>
            <SelectField
              name="head_of_department"
              onChange={(e) =>
                setDepartment({
                  ...DepartmentUnit,
                  head_of_department: e.value,
                })
              }
              options={AllEmployee}
              value={AllEmployee?.find(
                (item) => item?.value === DepartmentUnit?.head_of_department
              )}
            />
          </div>

          <div className="Box">
            <label>description</label>
            <input
              name="description"
              value={DepartmentUnit.description}
              onChange={(e) =>
                setDepartment({
                  ...DepartmentUnit,
                  description: e.target.value,
                })
              }
            />
          </div>

          {/* <div className="Box">
            <label>effective Status</label>
            <select
              name="effectiveStatus"
              value={DepartmentUnit.effective_status}
              onChange={(e) =>
                setDepartment({
                  ...DepartmentUnit,
                  effective_status: e.target.value,
                })
              }
              id=""
            >
              <option value="">Choose department</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>

          <div className="Box">
            <label>effective Start Date</label>
            <input
              type="date"
              name=""
              id=""
              value={DepartmentUnit.effective_start_date}
              onChange={(e) =>
                setDepartment({
                  ...DepartmentUnit,
                  effective_start_date: e.target.value,
                })
              }
            />
          </div> */}
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={DepthandleClose} className="Btn">
            Cancel
          </button>
          <button
            className="Btn"
            onClick={createDepartment}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "submit"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const EditDepartmentDialog = ({
  handleEditDeptClose,
  editDept,
  DepartmentUnit,
  setDepartment,
  AllEmployee,
  updateDepartment,
  isLoading,
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={handleEditDeptClose}
      aria-labelledby="customized-dialog-title"
      open={editDept !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleEditDeptClose}
      >
        <div className="foundation_header">Edit Department</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Form_Box">
          <div className="Box">
            <label>name</label>
            <input
              name="name"
              value={DepartmentUnit.name}
              onChange={(e) =>
                setDepartment({ ...DepartmentUnit, name: e.target.value })
              }
            />
          </div>

          <div className="Box">
            <label>Head of Department</label>
            <SelectField
              name="head_of_department"
              onChange={(e) =>
                setDepartment({
                  ...DepartmentUnit,
                  head_of_department: e.value,
                })
              }
              options={AllEmployee}
              value={AllEmployee?.find(
                (item) => item?.value === DepartmentUnit?.head_of_department
              )}
            />
          </div>

          <div className="Box">
            <label>description</label>
            <input
              name="description"
              value={DepartmentUnit.description}
              onChange={(e) =>
                setDepartment({
                  ...DepartmentUnit,
                  description: e.target.value,
                })
              }
            />
          </div>

          {/* <div className="Box">
            <label>effective Status</label>
            <select
              name="effectiveStatus"
              value={DepartmentUnit.effective_status}
              onChange={(e) =>
                setDepartment({
                  ...DepartmentUnit,
                  effective_status: e.target.value,
                })
              }
              id=""
            >
              <option value="">Choose department</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>

          <div className="Box">
            <label>effective Start Date</label>
            <input
              type="date"
              name=""
              id=""
              value={DepartmentUnit.effective_start_date}
              onChange={(e) =>
                setDepartment({
                  ...DepartmentUnit,
                  effective_start_date: e.target.value,
                })
              }
            />
          </div> */}
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={handleEditDeptClose} className="Btn">
            Cancel
          </button>
          <button
            className="Btn"
            onClick={updateDepartment}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "submit"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const DeleteDepartmentDialog = ({
  handleDeleteDeptClose,
  deleteDept,
  isLoading,
  deleteDepartment,
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={handleDeleteDeptClose}
      aria-labelledby="customized-dialog-title"
      open={deleteDept !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleDeleteDeptClose}
      >
        <div className="foundation_header">Delete Department</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Confirmation">Are you sure?</div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={handleDeleteDeptClose} className="Btn">
            Cancel
          </button>
          <button
            className="Delete_Btn"
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
            onClick={deleteDepartment}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "Delete"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const ViewDepartmentDialog = ({
  handleViewDeptClose,
  DeptViewopen,
  employee,
}) => {
  return (
    <BootstrapDialog
      onClose={handleViewDeptClose}
      aria-labelledby="customized-dialog-title"
      open={DeptViewopen !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleViewDeptClose}
      >
        <div className="foundation_header">View Department</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <List>
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Name</label>
            <p>{DeptViewopen?.name}</p>
          </ListItem>
          <Divider style={{ backgroundColor: "rgba(0,0,0,0.5" }} />
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Head of Department</label>
            <p>{`${employee?.label}`}</p>
          </ListItem>
          <Divider style={{ backgroundColor: "rgba(0,0,0,0.5" }} />
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Description</label>
            <p>{DeptViewopen?.description}</p>
          </ListItem>
        </List>
      </DialogContent>
    </BootstrapDialog>
  );
};
